import csiAction from "csi/action";
import Popup from "csi/action/Popup";
import def from "csi/def";
import Ref from "csi/heading/Ref";
import MaterialIcon from "csi/widget/MaterialIcon";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import csiView from "csi/view";
import html from "csi/html";
import { URL_SUBTYPE_CLO } from "csi/reflection/reflectionConstants";

const ThreeDMaterialDocumentRenderer = declare(Ref, {

	toHtmlStatic(ctx, h, refNode, actionData) {
		const url = this._getValue(ctx, h);
		const { view, bExcel, bPopup, bPrint } = ctx;
		const VIEWER = "3DMaterialViewer";

		if (xml.isValidURL(url) && this.isValid3DIcon(url, ctx) && !bPopup && !bExcel && !bPrint && !view.isPreview) {
			refNode = html.create("div", {
				class: "csi-flex-row",
			}, refNode);
    
			this.inherited(arguments);
			new MaterialIcon({
				icon: "3d_rotation",
				onClick: (): void => {
					const action = Object.assign(new Popup(), {
						classController: "csi/threeD/ViewerController",
						m_id: VIEWER,
						m_postAction: (ac) => {
							const { widget } = ac;
							const colorsView = csiView.getView("ProductColors");
							const documentsView = csiView.getView("Documents");
                        
							widget.postActionRefreshNode(ac);
                        
							if (widget !== colorsView) {
								colorsView?.refreshData();
							}
                        
							if (widget !== documentsView) {
								documentsView?.refreshData();
							}
						},
						m_typeControl: def.ACTION_ICON,
						dependencyPaths: ["Child:CurrentRevision"],
					});
					action.resolve();
					csiAction.invoke(view, refNode, action, {
						m_urlNode: url,
						getTitle: () => h.getLabel(),
					});
				},
			}).placeAt(refNode);
			return true;
		}
		return this.inherited(arguments);
	},
	
	/**
	 * Determines if the 3D icon should appear
	 * @param {cnl} url - CNL of the document node to check 
	 * @param {Context} ctx 
	 * @return {boolean} - true if the document should display a 3D icon, otherwise false
	 */	
	isValid3DIcon(url, ctx) {
		const node = ctx.cache.getNode(url);
		
		// Clo 3D materials are valid documents for the attribute, but aren't supported in the viewer so the icon shouldn't appear
		if (node != null && node.Subtype != URL_SUBTYPE_CLO) {
			return true;
		}
		
		return false;
	},
});

export = ThreeDMaterialDocumentRenderer;